<template>

  <HeaderSection />

  <section id="formulario" class="bg-gray-100 pb-52 pt-6">

    <Form class="space-y-4 text-gray-700">

      <div class="container mx-auto px-4 max-w-5xl">

        <h1 class="font-bold text-gray-800 mb-0 text-2xl text-center pt-5">
          PAGAR
        </h1>

        <!-- Formulario -->
        <div class="w-full mt-10">
          <div class="flex flex-col items-center text-center rounded-lg shadow-lg mt-4 bg-gray-200 p-10">
            <h2>
              REDIRIGIENDO A MERCADOPAGO...
            </h2>
          </div>
        </div>


        <div class="h-8">
        </div>

      </div>

    </Form>

  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Form } from 'vee-validate';
import Swal from 'sweetalert2'

import suiteService, { Acreditado, } from 'qreventos-suite/services';
import pagosServices, { Producto } from 'qreventos-suite/pagos';
import suiteConfig from '@/services/suite.config';
import { useRoute } from 'vue-router'
import HeaderSection from '@/components/HeaderSection.vue'

import { A_VERIFICAR } from "qreventos-suite/constantes";


export default defineComponent({
  components: {
    Form, HeaderSection
  },
  data() {
    return {
      productos: [] as Producto[],
      acreditado: undefined as unknown as Acreditado,
      producto: undefined as unknown as Producto,
    };
  },
  methods: {
    async pagar() {
      if (this.acreditado.dato3 != '41') {
        let productosDisponibles = await pagosServices.findProductosDisponiblesBy(suiteConfig.evento);

        let productosDisponible = productosDisponibles.find(p => p.id.toString() === this.acreditado.dato3) as Producto;
        if (!productosDisponible || productosDisponible.cantidadDisponible <= 0) {
          Swal.fire(
            {
              title: this.acreditado.dato4 + " - AGOTADO",
              text: 'El descuento  ' + this.acreditado.dato4 + ' no tiene más unidades disponibles, deberá abonar el valor completo del producto.',
              icon: "error",
              confirmButtonText: "Pagar valor completo $220.000",
            }).then(() => {
              this.producto = this.productos.find(p => p.id === 41) as Producto;
              this.redirigirMercadoPago();
            });
          return;
        }
        this.producto = productosDisponible;
      }

      this.redirigirMercadoPago();
    },
    async redirigirMercadoPago() {
      const ordenCompra: Object = {
        ordenCompra: {
          acreditado: { id: this.acreditado.id },
          itemsOrdenCompra: [
            {
              producto: { id: this.producto.id },
              cantidad: 1,
              precioUnitario: this.producto.precioUnitario,
              subtotal: this.producto.precioUnitario,
            },
          ],
          total: this.producto.precioUnitario,
        }
      };
      let responseObj = await pagosServices.pagar(suiteConfig.evento, this.acreditado.hash, ordenCompra);
      const response = new Map<string, string>(Object.entries(responseObj));
      const formUrl = response.get("formUrl");
      if (formUrl) {
        window.location.href = formUrl;
      }
    },
  },

  async mounted() {
    console.log("mounted");
    const route = useRoute();
    const hash = route.params.hash as string;
    this.acreditado = await suiteService.findAcreditadoByHash(suiteConfig.evento, hash) as Acreditado;

    this.productos = await pagosServices.findProductosDisponiblesBy(suiteConfig.evento);

    if (!this.acreditado) {
      Swal.fire({
        title: "¡Atention!",
        html: "El acreditado no existe o no se encuentra registrado.",
        icon: "error",
      }).then(() => {
        window.location.href = "https://acreditaciones.qreventos.com/forovacamuerta";
      });
      return;
    }

    if (this.acreditado.estadoAcreditado.id === A_VERIFICAR) {
      if (this.productos.length === 0) {
        Swal.fire(
          {
            title: "Entradas agotadas",
            text: 'Lamentamos informarle que las entradas se encuentran agotadas.',
            icon: "error"
          }).then(() => {
            window.location.href = "https://acreditaciones.qreventos.com/forovacamuerta";
          });
        return;
      }
      this.producto = this.productos.find(p => p.id.toString() === this.acreditado.dato3) as Producto;
      await this.pagar();
    } else {
      Swal.fire({
        title: "Atención",
        html: "Su pago ya se encuentra acreditado. <br>Se encuentra inscripto al evento.",
        icon: "warning"
      }).then(() => {
        window.location.href = "https://acreditaciones.qreventos.com/forovacamuerta";
      });
    }


  }
});
</script>